<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <!-- <b-card>
        <div slot="header">User Profile</div>-->
        <b-form @submit.prevent="save">
          <b-row>
            <b-col md="12">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Group Name</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="n_user.n_usergroup_edit.UserGroupName"
                    placeholder="Group Name"
                    required
                    autocomplete="off"
                    type="text"
                    id="UserGroupName"
                    @change.native="addDirtyField"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Notes</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="n_user.n_usergroup_edit.Notes"
                    placeholder=""
                    autocomplete="off"
                    type="text"
                    id="Notes"
                    @change.native="addDirtyField"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>

          <div class="form-group form-actions" style="float:right;">
            <b-button
              class="mr-2 mt-2"
              size="md"
              variant="outline-primary"
              @click="back"
            >
              <!-- <i class="fa fa-close"></i> -->
              Cancel
            </b-button>
            <b-button
              class="mr-0 mt-2"
              size="md"
              variant="primary"
              type="submit"
              :disabled="isClean"
            >
              <i class="fa fa-save"></i>
              Save
            </b-button>
          </div>
          <div class="form-group form-actions" style="float:right;">
            <b-alert
              class="btn mr-4 mt-2"
              :show="dismissCountDown"
              fade
              variant="light"
              :dismissed="(dismissCountdown = 0)"
              @dismiss-count-down="countDownChanged"
            >
              Your information has been saved
              <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
            </b-alert>
            <b-alert
              class="btn mr-4 mt-2"
              :show="dismiss2CountDown"
              fade
              variant="danger"
              :dismissed="(dismiss2Countdown = 0)"
              @dismiss-count-down="countDown2Changed"
            >
              Your information could not be saved. Check all fields carefully.
              <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
            </b-alert>
            <b-alert
              class="btn mr-4 mt-2"
              :show="dismiss3CountDown"
              fade
              variant="danger"
              :dismissed="(dismiss3Countdown = 0)"
              @dismiss-count-down="countDown3Changed"
            >
              Group already exists! Your information could not be saved.
              <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
            </b-alert>
          </div>
        </b-form>
        <!-- </b-card> -->
      </b-col>
    </b-row>
    <UserListSubset :group_object="n_user.n_usergroup_edit" />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import EmployeeCard from "@/components/cards/EmployeeCard.vue";
import UserListSubset from "@/components/CustomSubComponents/UserListSubset.vue";

import { required, email, helpers } from "vuelidate/lib/validators";
import { CoolSelect } from "vue-cool-select";
const alpha = helpers.regex("alpha", /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/);
export default {
  name: "UserGroupProfile",
  components: {
    EmployeeCard,
    CoolSelect,
    UserListSubset
  },
  data() {
    return {
      selected: [], // Must be an array reference!
      dirtyFields: [],
      show: true,
      seen: true,
      isSaving: false,
      isSaved: false,
      dismissSecs: 3,
      dismissCountDown: 0,
      dismiss2Secs: 3,
      dismiss2CountDown: 0,
      dismiss3Secs: 3,
      dismiss3CountDown: 0,
      showDismissibleAlert: false
    };
  },
  mounted() {
    this.$store.state.saveOp.localUrl = "/User/SaveUserGroup/";
    this.$store.state.saveOp.localVariableName = "_ug";
    this.$store.state.saveOp.localVariableObject = this.$store.state.n_user.n_usergroup_edit;
    this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    this.$store.state.saveOp.localFieldToSet = "UserGroupID";
    this.$store.state.saveOp.localReturnObject = "SaveUserGroupResult";
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    toggleVisibility() {
      this.seen = !this.seen;
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    countDown2Changed(dismiss2CountDown) {
      this.dismiss2CountDown = dismiss2CountDown;
    },
    countDown3Changed(dismiss3CountDown) {
      this.dismiss3CountDown = dismiss3CountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    saveTest() {
      this.$v.$touch();
      if (this.$v.$error) {
        this.dismiss2CountDown = this.dismiss2Secs;
      } else {
        this.$store
          .dispatch("saveOp/Save", {
            _saveOp: {
              Url: "/User/SaveUser/",
              Data: {
                _up: this.$store.state.n_user.n_user_edit,
                _newValues: this.dirtyFields,
                ReturnMap: this.$store.state.n_user.n_user_edit.UserProfileID
              }
            }
          })
          .then(
            (this.dirtyFields = [])((this.dismissCountDown = this.dismissSecs))
          );
      }
    },
    saveTest2() {
      this.$v.$touch();
      if (this.$v.$error) {
        this.dismiss2CountDown = this.dismiss2Secs;
      } else {
        this.$store.state.saveOp.SaveOperation = {
          Url: "/User/SaveUser/",
          Data: {
            _up: this.$store.state.n_user.n_user_edit,
            _newValues: this.dirtyFields,
            ReturnMap: this.$store.state.n_user.n_user_edit.UserProfileID
          }
        };
        this.$store
          .dispatch("saveOp/EmitSave")
          .then(
            (this.dirtyFields = [])((this.dismissCountDown = this.dismissSecs))
          );
      }
    },
    save() {
      if (
        this.$store.state.n_user.n_usergroup_edit.UserGroupID !== -1 &&
        this.$store.state.n_user.n_usergroups.find(
          group =>
            group.UserGroupID !==
              this.$store.state.n_user.n_usergroup_edit.UserGroupID &&
            group.UserGroupName.toLowerCase() ===
              this.$store.state.n_user.n_usergroup_edit.UserGroupName.toLowerCase()
        )
      ) {
        this.dismiss3CountDown = this.dismiss3Secs;
        return;
      }

      this.$v.$touch();
      if (this.$v.$error) {
        this.dismiss2CountDown = this.dismiss2Secs;
      } else {
        this.$store
          .dispatch("saveOp/BuildSaveOperation")
          .then(
            this.$store
              .dispatch("saveOp/EmitSave")
              .then(
                (this.dirtyFields = []),
                (this.dismissCountDown = this.dismissSecs),
                this.$store.state.saveOp.DestroySaveOperation
              )
          );

        // this.$store
        //   .dispatch("saveOp/BuildSaveOperation")
        //   .then(this.$store.dispatch.dispatch("saveOp/EmitSave"))
        //   .then(
        //     (this.dirtyFields = [])((this.dismissCountDown = this.dismissSecs))
        //   );
      }
    },
    saveOriginal() {
      this.$v.$touch();
      if (this.$v.$error) {
        this.dismiss2CountDown = this.dismiss2Secs;
      } else {
        this.$store
          .dispatch("n_user/Save", {
            user: this.$store.state.n_user.n_user_edit,
            fields: this.dirtyFields
          })
          .then(
            (this.dirtyFields = [])((this.dismissCountDown = this.dismissSecs))
          );

        //.then(alert(this.$store.state.n_user.n_user_edit.UserProfileID));
      }
    },
    greet: function(event) {
      //alert(event.target.id);
      //alert(event.target.id);
      //alert("Hello " + this.target.id + "!");
    },
    addDirtyField: function(event) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== event.target.id
      );
      this.dirtyFields.push({
        FieldName: event.target.id,
        FieldValue: event.target.value
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
    addDirtyFieldWatch: function(field, newValue) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== field
      );
      this.dirtyFields.push({
        FieldName: field,
        FieldValue: newValue
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
    addDirtyFieldRadio: function(event) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== "IsSU"
      );
      this.dirtyFields.push({
        FieldName: "IsSU",
        FieldValue: event.target.value
      });
    },
    togglePassword: function() {
      const passwordField = document.querySelector("#Password");
      if (passwordField.getAttribute("type") === "password") {
        passwordField.setAttribute("type", "text");
      } else {
        passwordField.setAttribute("type", "password");
      }
    }
  },
  computed: {
    ...mapState(["n_user", "saveOp"]),
    ...mapActions("n_user", ["SaveGroup"]),
    ...mapActions("saveOp", ["Save", "EmitSave"]),
    isClean() {
      return this.dirtyFields.length === 0;
    }
  },

  validations: {
    n_user: {
      n_usergroup_edit: {
        UserGroupName: {
          required
        }
      }
    }
  },
  watch: {}
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.input-group-text {
  color: #111;
}
</style>
